import script from "./terminal-discovery.vue?vue&type=script&lang=ts&setup=true"
export * from "./terminal-discovery.vue?vue&type=script&lang=ts&setup=true"

import "./terminal-discovery.vue?vue&type=style&index=0&id=3708100b&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3708100b"]])

export default __exports__